import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Redirect } from "react-router-dom";
import { fetchViewProfile } from "../actions/viewProfileActions";
import { fetchSecurityQuestions } from "../actions/editProfileActions";
import { clearMyProfileRedirectNotification } from "../actions/submitEditProfileActions";
import { sessionSelector } from "@ufginsurance/sso-oidc-client-react";
import { ErrorCodes } from "../constants/errorCodes";
import { MY_PROFILE_ROUTE } from "../constants/routes";
import EditProfile from "../components/edit-profile/EditProfile";
import ErrorBoundary from "../components/ErrorBoundary";
import { Translations } from "../components/translations";
import CustomErrorView from "../components/CustomErrorView";
import { fetchAutomaticPayments } from "../actions/automaticPaymentsAction";
import { fetchdownIndicatorInfo } from "../components/behaviors/DownIndicatorBehavior";

class EditMyProfileContainer extends Component {
  static propTypes = {
    profileData: PropTypes.object,
    editProfileData: PropTypes.object,
    submitProfileData: PropTypes.object,
    fetchViewProfile: PropTypes.func.isRequired,
    fetchSecurityQuestions: PropTypes.func.isRequired,
    clearMyProfileRedirectNotification: PropTypes.func.isRequired,
    isEditableSession: PropTypes.bool.isRequired,
    fetchAutomaticPayments: PropTypes.func.isRequired,
    automaticPaymentsData: PropTypes.object.isRequired,
    fetchdownIndicatorInfo: PropTypes.func.isRequired
  };

  componentDidMount() {
    this.props.fetchViewProfile();
    this.props.fetchSecurityQuestions();
    this.props.fetchdownIndicatorInfo();

    const { accounts, error, isLoading } = this.props.automaticPaymentsData;
    if (!accounts?.length && !isLoading && !error) {
      this.props.fetchAutomaticPayments();
    }
  }

  componentWillUnmount() {
    this.props.clearMyProfileRedirectNotification();
  }

  render() {
    const {
      profileData,
      editProfileData,
      submitProfileData,
      isEditableSession
    } = this.props;

    const isLoading =
      this.props.automaticPaymentsData?.isLoading ||
      (profileData && profileData.isLoading) ||
      (editProfileData && editProfileData.isLoading) ||
      (submitProfileData && submitProfileData.isLoading);

    const errors = [
      profileData && profileData.error,
      editProfileData && editProfileData.error,
      submitProfileData && submitProfileData.error
    ].filter(error => !!error);

    const hasUserSecurityQuestions =
      profileData.userProfile &&
      profileData.userProfile.security_questions &&
      profileData.userProfile.security_questions.length > 0;

    const hasAvailableSecurityQuestions =
      editProfileData.securityQuestions &&
      editProfileData.securityQuestions.length > 0;

    if (submitProfileData && submitProfileData.redirectToMyProfile) {
      return <Redirect to={MY_PROFILE_ROUTE} />;
    }

    return (
      <ErrorBoundary statusCode={ErrorCodes.ServerError}>
        <div className="form-controls">
          {errors && errors.length > 0 && (
            <CustomErrorView
              error={errors[0]}
              errorLocationInTranslation={Translations.user_profile.error_codes}
            />
          )}
          <div>

            <EditProfile
              loadingComplete={!isLoading && hasUserSecurityQuestions && hasAvailableSecurityQuestions}
              userProfile={profileData.userProfile}
              securityQuestions={editProfileData.securityQuestions}
              isEditableSession={isEditableSession}
            />
          </div>
        </div>
      </ErrorBoundary>
    );
  }
}

const mapStateToProps = state => ({
  profileData: state.profileData,
  editProfileData: state.editProfileData,
  submitProfileData: state.submitProfileData,
  isEditableSession: sessionSelector.policyholderHasWriteAccess(state),
  automaticPaymentsData: state.automaticPaymentsData
});

const mapDispatchToProps = {
  fetchViewProfile,
  fetchSecurityQuestions,
  clearMyProfileRedirectNotification,
  fetchAutomaticPayments,
  fetchdownIndicatorInfo
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditMyProfileContainer);
